module.exports = __webpack_public_path__ + "static/img/grh.3b5b2b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grh.png
// module id = yqJG
// module chunks = 1